import { render, staticRenderFns } from "./multiScreenMenu.vue?vue&type=template&id=2a90e348&"
import script from "./multiScreenMenu.vue?vue&type=script&lang=js&"
export * from "./multiScreenMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports